import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Tauro from "./pages/Tauro";
import Admin from "./pages/Admin";
import TablaJaladora from "./pages/TablaJaladora";
import Numerologia from "./pages/Numerologia";
import Suenos from "./pages/Suenos";
import Interpretar from "./pages/Interpretar";
import HorasEspejo from "./pages/HorasEspejo";
import { Toaster } from "./components/ui/toaster";
import { RecommendationsProvider } from "./context/RecommendationsContext";
import { SearchProvider } from "./context/SearchContext";
import { AuthProvider } from "./context/AuthContext";
import { LogoFilterDefs } from "./components/LotteryLogo";
import useVisitTracker from "./hooks/useVisitTracker";

function VisitTracker() {
  useVisitTracker();
  return null;
}

function App() {
  return (
    <div className="App">
      <LogoFilterDefs />
      <AuthProvider>
        <RecommendationsProvider>
          <SearchProvider>
            <BrowserRouter>
              <VisitTracker />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tauro" element={<Tauro />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/tabla-jaladora" element={<TablaJaladora />} />
                <Route path="/numerologia" element={<Numerologia />} />
                <Route path="/suenos" element={<Suenos />} />
                <Route path="/interpretar" element={<Interpretar />} />
                <Route path="/horas-espejo" element={<HorasEspejo />} />
              </Routes>
            </BrowserRouter>
          </SearchProvider>
        </RecommendationsProvider>
      </AuthProvider>
      <Toaster />
    </div>
  );
}

export default App;
